import {
  AltTransMeasure,
  AltTransMeasureType,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { FC, useMemo, useState } from "react";
import {
  Badge,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "shared/components/Spor";

type MeasureBadgesProps = {
  measures: AltTransMeasure[];
};

function labelForMeasureType(measureType: AltTransMeasureType) {
  switch (measureType) {
    case AltTransMeasureType.NEXT_TRAIN:
      return "Neste tog";
    case AltTransMeasureType.NO_COVERAGE:
      return "Ingen dekning";
    case AltTransMeasureType.OTHER_PROVIDER_REFERRAL:
      return "Annen leverandør";
    case AltTransMeasureType.OTHER_TRAINS:
      return "Andre tog";
    case AltTransMeasureType.REPLACEMENT_TRIP:
      return "Togtiltak";
    case AltTransMeasureType.SHUTTLE:
      return "Pendel";
  }
}

export const MeasureBadges: FC<MeasureBadgesProps> = ({ measures }) => {
  const [showPopover, setShowPopover] = useState(false);
  if (measures.length === 0) return;

  const [first, ...rest] = useMemo(
    () =>
      measures.toSorted((a, b) => {
        // Sort any "no coverage" measures to the beginning of the list
        if (a.type === AltTransMeasureType.NO_COVERAGE) return -1;
        if (b.type === AltTransMeasureType.NO_COVERAGE) return 1;
        return 0;
      }),
    [measures],
  );

  return (
    <>
      <Badge
        colorPalette={
          first.type === AltTransMeasureType.NO_COVERAGE ? "yellow" : "green"
        }
      >
        {labelForMeasureType(first.type)}
      </Badge>

      {rest && rest.length > 0 && (
        <Popover open={showPopover} positioning={{ placement: "right" }}>
          <PopoverTrigger>
            <Badge
              colorPalette="green"
              onMouseEnter={() => setShowPopover(true)}
              onFocus={() => setShowPopover(true)}
              onMouseLeave={() => setShowPopover(false)}
              onBlur={() => setShowPopover(false)}
            >
              +{rest.length}
            </Badge>
          </PopoverTrigger>

          <PopoverContent display="flex" flexWrap="wrap" gap="1">
            {rest.map((measure, i) => (
              <Badge
                // eslint-disable-next-line react/no-array-index-key -- no better alternative; measure type is not unique
                key={i}
                colorPalette={
                  measure.type === AltTransMeasureType.NO_COVERAGE
                    ? "yellow"
                    : "green"
                }
              >
                {labelForMeasureType(measure.type)}
              </Badge>
            ))}
          </PopoverContent>
        </Popover>
      )}
    </>
  );
};
